"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedProxyGuestChatRequestTimeout =
/*#__PURE__*/
function (_pb_1$ProxyGuestChatR) {
  _inherits(ExtendedProxyGuestChatRequestTimeout, _pb_1$ProxyGuestChatR);

  function ExtendedProxyGuestChatRequestTimeout(properties) {
    var _this;

    _classCallCheck(this, ExtendedProxyGuestChatRequestTimeout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedProxyGuestChatRequestTimeout).call(this, properties));
    _this.type = ExtendedProxyGuestChatRequestTimeout.type;
    _this.chreqid = properties.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedProxyGuestChatRequestTimeout, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.proxy.guest).concat(ExtendedProxyGuestChatRequestTimeout.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.ProxyGuestChatRequestTimeout.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedProxyGuestChatRequestTimeout(pb_1.ProxyGuestChatRequestTimeout.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedProxyGuestChatRequestTimeout;
}(pb_1.ProxyGuestChatRequestTimeout);

ExtendedProxyGuestChatRequestTimeout.type = "ProxyGuestChatRequestTimeout";
ExtendedProxyGuestChatRequestTimeout.context = "/guest-chat/cancel/timeout";
exports.ProxyGuestChatRequestTimeout = ExtendedProxyGuestChatRequestTimeout;